import { getDateFormat } from '../../../../utils/common-methods';
import { ERROR_MODAL_STATUSES } from '../../constants';
import { toTrimmedString } from './shared';

const GLOBAL_ERROR_MODAL_STATUSES = new Set(ERROR_MODAL_STATUSES);
const FALLBACK_ERROR_MESSAGE = 'An unexpected error occurred. Please try again.';

const resolveValidationDetails = (errorData = {}) => {
  const validationDetails = errorData?.validationError ?? errorData?.validationErrors;
  return Array.isArray(validationDetails) ? validationDetails : [];
};

const formatValidationEntry = (entry) => {
  if (!entry) return '';
  if (typeof entry === 'string') return toTrimmedString(entry);

  const name = toTrimmedString(entry?.name) || `Sublocation ${entry?.id ?? ''}`.trim();
  const issue = toTrimmedString(entry?.issue) || 'validation';
  const issueLabel = issue ? issue.toUpperCase() : 'VALIDATION';

  const lastStartDate = entry?.lastPosting?.startDate ? getDateFormat(entry.lastPosting.startDate) : '';
  const lastEndDate = entry?.lastPosting?.endDate ? getDateFormat(entry.lastPosting.endDate) : '';
  const hasRange = Boolean(lastStartDate && lastEndDate);
  const postingRange = hasRange ? ` (last posting: ${lastStartDate} - ${lastEndDate})` : '';

  return `${name} — ${issueLabel}${postingRange}`;
};

export const buildWeeklyGLErrorMessage = (error) => {
  const errorData = error?.data ?? error ?? {};
  const backendMessage = toTrimmedString(errorData?.message);
  const genericMessage = toTrimmedString(error?.message);
  const fetchErrorMessage = toTrimmedString(error?.error);
  const rawErrorDataMessage = typeof errorData === 'string' ? toTrimmedString(errorData) : '';
  const statusMessage = toTrimmedString(String(errorData?.status ?? errorData?.originalStatus ?? error?.status ?? ''));
  let serializedErrorData = '';
  if (!backendMessage && !genericMessage && !fetchErrorMessage && !rawErrorDataMessage && errorData) {
    try {
      serializedErrorData = toTrimmedString(JSON.stringify(errorData));
      if (serializedErrorData === '{}' || serializedErrorData === '[]' || serializedErrorData === 'null') {
        serializedErrorData = '';
      }
    } catch (serializationError) {
      serializedErrorData = '';
    }
  }

  const headerMessage =
    backendMessage ||
    genericMessage ||
    fetchErrorMessage ||
    rawErrorDataMessage ||
    statusMessage ||
    serializedErrorData;

  const details = resolveValidationDetails(errorData).map(formatValidationEntry).filter(Boolean);

  const formattedMessage = [headerMessage, ...details].filter(Boolean).join('\n');
  return formattedMessage || FALLBACK_ERROR_MESSAGE;
};

export const shouldShowWeeklyGLLocalErrorModal = (error) => {
  const status = error?.status ?? error?.data?.status;
  const originalStatus = error?.originalStatus ?? error?.data?.originalStatus;

  if (GLOBAL_ERROR_MODAL_STATUSES.has(status)) return false;
  if (GLOBAL_ERROR_MODAL_STATUSES.has(originalStatus)) return false;

  return true;
};
